export const toggleShowPublic = () => {
   return {
     type: 'SHOW_PUBLIC'
   }
}
